import React, { useState, useEffect,useCallback } from 'react';
import { db } from './firebase';
import { ref, onValue, set } from 'firebase/database';
import '../App.css';

const teams = {
  teams_logos: [
    { name: "Wolf Musta", logoUrl: "https://files.eliteprospects.com/layout/logos/f667f640-87d9-4879-b248-dde1387fac00_large.png" },
   
    { name: "Wolf Keltainen", logoUrl: "https://files.eliteprospects.com/layout/logos/f667f640-87d9-4879-b248-dde1387fac00_large.png" },
    
    { name: "Haki Sininen", logoUrl: "https://static.jopox.fi/harjunkiekko/logos/logo-300.png" },
    { name: "Haki Valkoinen", logoUrl: "https://static.jopox.fi/harjunkiekko/logos/logo-300.png" },
    { name: "HIFK Red", logoUrl: "https://hifk.fi/wp-content/themes/hifk/assets/images/ifk.svg" },
    { name: "HIFK White", logoUrl: "https://hifk.fi/wp-content/themes/hifk/assets/images/ifk.svg" },
    { name: "HIFK Grey", logoUrl: "https://hifk.fi/wp-content/themes/hifk/assets/images/ifk.svg" },
    { name: "HIFK Blue", logoUrl: "https://hifk.fi/wp-content/themes/hifk/assets/images/ifk.svg" },
    { name: "Kiekko Tiikerit", logoUrl: "https://kiekko-tiikerit.fi/wp-content/uploads/2020/12/tiikerit_logo_transparent_1600-1.png" },
    { name: "KiVa Lohet", logoUrl: "https://upload.wikimedia.org/wikipedia/fi/thumb/5/52/Kiekko-Vantaa_logo.svg/1200px-Kiekko-Vantaa_logo.svg.png" },
    { name: "KiVa Taimenet", logoUrl: "https://upload.wikimedia.org/wikipedia/fi/thumb/5/52/Kiekko-Vantaa_logo.svg/1200px-Kiekko-Vantaa_logo.svg.png" },
    { name: "Hunters White", logoUrl: "https://static.jopox.fi/hunters/logos/logo-600.png" },
    { name: "Kurra", logoUrl: "https://sportti.org/site/assets/files/1298/kurra-2023-original.webp" },

  ]
};

const LauantaiU8 = ({ isAdmin }) => {
    const teams_name = {
        U8_lohko_A: [
          { name: "Wolf Keltainen", logoUrl: "https://files.eliteprospects.com/layout/logos/f667f640-87d9-4879-b248-dde1387fac00_large.png" },
          { name: "KiVa Lohet", logoUrl: "https://upload.wikimedia.org/wikipedia/fi/thumb/5/52/Kiekko-Vantaa_logo.svg/1200px-Kiekko-Vantaa_logo.svg.png" },
          { name: "HIFK Red", logoUrl: "https://hifk.fi/wp-content/themes/hifk/assets/images/ifk.svg" },
          { name: "Haki Sininen", logoUrl: "https://static.jopox.fi/harjunkiekko/logos/logo-300.png" },
          { name: "Kiekko Tiikerit", logoUrl: "https://kiekko-tiikerit.fi/wp-content/uploads/2020/12/tiikerit_logo_transparent_1600-1.png" },
        ],
        U8_lohko_B: [
          { name: "Wolf Musta", logoUrl: "https://files.eliteprospects.com/layout/logos/f667f640-87d9-4879-b248-dde1387fac00_large.png" },
          { name: "KiVa Taimenet", logoUrl: "https://upload.wikimedia.org/wikipedia/fi/thumb/5/52/Kiekko-Vantaa_logo.svg/1200px-Kiekko-Vantaa_logo.svg.png" },
          { name: "HIFK White", logoUrl: "https://hifk.fi/wp-content/themes/hifk/assets/images/ifk.svg" },
          { name: "HIFK Blue", logoUrl: "https://hifk.fi/wp-content/themes/hifk/assets/images/ifk.svg" },
          { name: "Haki Valkoinen", logoUrl: "https://static.jopox.fi/harjunkiekko/logos/logo-300.png" },

        ]
      };
  const defaultGames = {
    U8_lohko_A: [
        { id: 1, time: '11:15', team1: 'Wolf Keltainen', team2: 'KiVa Lohet', result1: '', result2: '', status:'' },
        { id: 2, time: '11:45', team1: 'KiVa Lohet', team2: 'Kiekko Tiikerit', result1: '', result2: '', status:'' },
        { id: 3, time: '12:15', team1: 'Wolf Keltainen', team2: 'Kiekko Tiikerit', result1: '', result2: '', status:'' },
        { id: 4, time: '15:00', team1: 'HIFK Red', team2: 'Haki Sininen', result1: '', result2: '', status:'' },
        { id: 5, time: '15:30', team1: 'HIFK Red', team2: 'KiVa Lohet', result1: '', result2: '', status:'' },
        { id: 6, time: '16:00', team1: 'Haki Sininen', team2: 'Kiekko Tiikerit', result1: '', result2: '', status:'' },
        { id: 7, time: '16:45', team1: 'Wolf Keltainen', team2: 'HIFK Red', result1: '', result2: '', status:'' },
        { id: 8, time: '17:15', team1: 'Haki Sininen', team2: 'KiVa Lohet', result1: '', result2: '', status:'' },
        { id: 9, time: '18:05', team1: 'Kiekko Tiikerit', team2: 'HIFK Red', result1: '', result2: '', status:'' },
        { id: 10, time: '18:45', team1: 'Wolf Keltainen', team2: 'Haki Sininen', result1: '', result2: '', status:'' }
    ],
   
    U8_lohko_B: [         
        
    { id: 1, time: '11:15', team1: 'Wolf Musta', team2: 'KiVa Taimenet', result1: '', result2: '', status:'' },
    { id: 2, time: '11:45', team1: 'HIFK Blue', team2: 'KiVa Taimenet', result1: '', result2: '', status:'' },
    { id: 3, time: '12:15', team1: 'HIFK Blue', team2: 'Wolf Musta', result1: '', result2: '', status:'' },
    { id: 4, time: '15:00', team1: 'Haki Valkoinen', team2: 'HIFK White', result1: '', result2: '', status:'' },
    { id: 5, time: '15:30', team1: 'Haki Valkoinen', team2: 'KiVa Taimenet', result1: '', result2: '', status:'' },
    { id: 6, time: '16:00', team1: 'HIFK White', team2: 'HIFK Blue', result1: '', result2: '', status:'' },
    { id: 7, time: '16:45', team1: 'Wolf Musta', team2: 'Haki Valkoinen', result1: '', result2: '', status:'' },
    { id: 8, time: '17:15', team1: 'HIFK White', team2: 'KiVa Taimenet', result1: '', result2: '', status:'' },
    { id: 9, time: '18:05', team1: 'Haki Valkoinen', team2: 'HIFK Blue', result1: '', result2: '', status:'' },
    { id: 10, time: '18:45', team1: 'Wolf Musta', team2: 'HIFK White', result1: '', result2: '', status:'' }]
  };
  const [games, setGames] = useState(defaultGames);
  const [activeTab, setActiveTab] = useState("A");
  const [selectedSubTab, setSelectedSubTab] = useState('games');

  useEffect(() => {
    const fetchGameData = async () => {
      const dbRef = ref(db, "games/lauantai/U8");
      onValue(dbRef, (snapshot) => {
        const data = snapshot.val();
        if (data) {
          setGames((prevGames) => ({
            ...prevGames,
            ...data,
          }));
        }
      });
    };
    fetchGameData();
  }, []);

  // Function to handle score change
  const handleResultChange = (lohko, gameId, resultField, newValue) => {
    setGames((prevGames) => {
      const updatedGames = { ...prevGames };
      const gameIndex = updatedGames[lohko].findIndex((game) => game.id === gameId);

      if (gameIndex !== -1) {
        updatedGames[lohko][gameIndex] = {
          ...updatedGames[lohko][gameIndex],
          [resultField]: newValue,
        };
      }

      return updatedGames;
    });
  };
 
  // Save the updated game data back to Firebase
  const handleSave = () => {
    const dbRef = ref(db, `games/lauantai/U8/${lohko}`);
    set(dbRef, games[lohko])
      .then(() => {
        alert("Games saved successfully!");
      })
      .catch((error) => {
        console.error("Error saving data: ", error);
        alert("Failed to save games.");
      });
  };

  // Calculate the standings based on game results
  const calculateTeamStats = useCallback((lohko) => {
    const groupGames = games[lohko];
    const teamStats = {};
  
    groupGames.forEach((game) => {
      const team1 = game.team1;
      const team2 = game.team2;
  
      if (!teamStats[team1]) {
        teamStats[team1] = {
          name: team1, win: 0, loss: 0, draw: 0, points: 0,
          goalsFor: 0, goalsAgainst: 0, gamesPlayed: 0
        };
      }
      if (!teamStats[team2]) {
        teamStats[team2] = {
          name: team2, win: 0, loss: 0, draw: 0, points: 0,
          goalsFor: 0, goalsAgainst: 0, gamesPlayed: 0
        };
      }
  
      const result1 = parseInt(game.result1);
      const result2 = parseInt(game.result2);
  
      if (!isNaN(result1) && !isNaN(result2)) {
        // Update goals
        teamStats[team1].goalsFor += result1;
        teamStats[team1].goalsAgainst += result2;
        teamStats[team2].goalsFor += result2;
        teamStats[team2].goalsAgainst += result1;
  
        // Update results
        if (result1 > result2) {
          teamStats[team1].win++;
          teamStats[team1].points += 2;
          teamStats[team2].loss++;
        } else if (result1 < result2) {
          teamStats[team2].win++;
          teamStats[team2].points += 2;
          teamStats[team1].loss++;
        } else {
          teamStats[team1].draw++;
          teamStats[team2].draw++;
          teamStats[team1].points += 1;
          teamStats[team2].points += 1;
        }
  
        teamStats[team1].gamesPlayed++;
        teamStats[team2].gamesPlayed++;
      }
    });
  
    return Object.values(teamStats).sort((a, b) => {
      if (b.points !== a.points) return b.points - a.points;
      const goalDiffA = a.goalsFor - a.goalsAgainst;
      const goalDiffB = b.goalsFor - b.goalsAgainst;
      if (goalDiffB !== goalDiffA) return goalDiffB - goalDiffA;
      return b.goalsFor - a.goalsFor;
    });
  }, [games]);

  const lohko = `U8_lohko_${activeTab}`;

  return (
    <div className="game-container">
     <h4 className ='date-title'>Lauantai 17.05.2025</h4>
    <hr></hr>
    <h2>U8 otteluohjelma</h2>
    <div className="tab-container">
  <div
    className="highlight-slider"
    style={{
      transform: activeTab === 'A' ? 'translateX(0%)' : 'translateX(100%)',
    }}
  />
  <button
    className={`U8-lohko-tab-button ${activeTab === 'A' ? 'active' : ''}`}
    onClick={() => setActiveTab('A')}
  >
    Lohko A
  </button>
  <button
    className={`U8-lohko-tab-button ${activeTab === 'B' ? 'active' : ''}`}
    onClick={() => setActiveTab('B')}
  >
    Lohko B
  </button>
</div>
       {/* Dynamically render content based on activeTab */}
       <h2 className='team-list-title'>{`Joukkueet | Lohko ${lohko.slice(-1)}`}</h2>
    <div className="team-list">
        {teams_name[lohko]?.length > 0 ? (
          <div className="team-container">
            {teams_name[lohko].map((team, index) => (
              <div key={index} className="team-item">
                <img src={team.logoUrl || 'default-logo.png'} alt={team.name} className="team-logo" />
                <span className="teamlist-name">{team.name}</span>
              </div>
            ))}
          </div>
        ) : (
          <p>No teams available</p>
        )}
      </div>
      {/* Sub Tabs */}
      <div className="tab-container">
        <div
          className="highlight-slider"
          style={{ transform: selectedSubTab === 'games' ? 'translateX(0%)' : 'translateX(100%)' }}
        />
        <button
          className={`lohko-tab-button ${selectedSubTab === 'games' ? 'active' : ''}`}
          onClick={() => setSelectedSubTab('games')}
        >
          Ottelut
        </button>
        <button
          className={`lohko-tab-button ${selectedSubTab === 'lohkotilanne' ? 'active' : ''}`}
          onClick={() => setSelectedSubTab('lohkotilanne')}
        >
          Lohkotilanne
        </button>
      </div>
          {/* Conditional Rendering Based on Selected Tab */}
          {selectedSubTab === "games" && (
              <div className="lohko-games">
              <h2>{`Ottelut | Lohko ${activeTab}`}</h2>
                {/* Render games for the regular lohko */}
                {games[lohko]?.map((game) => (
            <div className="game-info" key={game.id}>
              <div className="game-info-header">
                <div className="game-row">Klo {game.time}</div>
                      <div className="game-row"> 
                      {lohko === "U8_lohko_A" && "(Lehvosen pääty)"}
                        {lohko === "U8_lohko_B" && "(Kellopääty)"}
                      </div>
                   </div>
                   {isAdmin && (
                     <div className="game-row save-button-container">
                       <button onClick={() => handleSave(game.id)} className="save-button">Tallenna</button>
                     </div>
                   )}
                 <div className="game-row">
                 <table className="game-table">
 <tbody>
   <tr>
     <td className="team-logo-cell">
       <img
         src={teams.teams_logos.find((team) => team.name === game.team1)?.logoUrl || "default-logo.png"}
         alt={game.team1}
         className="team-logo"
       />
     </td>
     <td className='game-result'>
       {isAdmin ? (
         <input
           type="text"
           value={game.result1}
           onChange={(e) => handleResultChange(lohko, game.id, 'result1', e.target.value)}
           placeholder="0"
           className="game-result-input"
         />
       ) : (
         <span className="game-result-text">{game.result1 || '0'}</span>
       )}
     </td>
     <td className="separator">-</td>
     <td className='game-result'>
       {isAdmin ? (
         <input
           type="text"
           value={game.result2}
           onChange={(e) => handleResultChange(lohko, game.id, 'result2', e.target.value)}
           placeholder="0"
           className="game-result-input"
         />
       ) : (
         <span className="game-result-text">{game.result2 || '0'}</span>
       )}
     </td>
     <td className="team-logo-cell">
       <img
         src={teams.teams_logos.find((team) => team.name === game.team2)?.logoUrl || "default-logo.png"}
         alt={game.team2}
         className="team-logo"
       />
     </td>
   </tr>
   <tr>
     <td className="team-name">{game.team1}</td>
     <td colSpan="3"></td>
     <td className="team-name">{game.team2}</td>
   </tr>
 </tbody>
</table>

                 </div>
               </div>
                ))}

              </div>
            )}

          {selectedSubTab === "lohkotilanne" && (
             <div className="lohko-standings">
               <h2>{`Lohkotilanne | Lohko ${activeTab}`}</h2>
              <table className="ranking-table">
                <thead>
                  <tr>
                    <th style={{width:'6px'}}>Sija</th>
                    <th>Joukkue</th>
                    <th>Ott</th>
                    <th>V</th>
                    <th>H</th>
                    <th>T</th>
                    <th>TM-HM</th>
                    <th>Pst</th>
                  </tr>
                </thead>
                <tbody>
                  {calculateTeamStats(lohko).map((teamStats,index) => (
                    <tr key={teamStats.name}>
                      <td style={{ width: '6px' }}> {index + 1}</td>
                      <td style = {{textAlign:'left'}}>
                      <img
                          style={{ width: '25px', height: '25px', marginRight: '8px', verticalAlign: 'middle' }} 
                          src={teams.teams_logos.find((team) => team.name === teamStats.name)?.logoUrl || "default-logo.png"}
                          alt={teamStats.name}
                        />
                        {teamStats.name}
                      </td>
                      <td>{teamStats.gamesPlayed}</td>
                      <td>{teamStats.win}</td>
                      <td>{teamStats.loss}</td>
                      <td>{teamStats.draw}</td>
                      <td>{teamStats.goalsFor}-{teamStats.goalsAgainst}</td>
                      <td>{teamStats.points}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
  );
};

export default LauantaiU8;
